class LinkNotification {

  [x: string]: any;

  static $inject = ['NotificationsService'];

  constructor(NotificationsService) {
    this.NotificationsService = NotificationsService;
  }

  translateKey() {
    return  'NOTIFICATION.LINK.' + this.notification.linkText
  }

  linkClick() {
    this.NotificationsService.delete({id: this.notification.notificationId}, () => {
      window.location.href = this.notification.linkHref;
    })
  }
}

export default {
  controller: LinkNotification,
  template: require('./link.notification.html'),
  bindings: {
    notification: '<',
  }
};
